import React from 'react';
// css file
import './features.css';
// components file
import Header from '../components/Home/Header';
import AdvertiseScreen from '../components/advertise/AdvertiseScreen';

const Advertise = () => {
  return (
    <div>
        <Header/>
        <AdvertiseScreen/>
    </div>
  )
}

export default Advertise;
